module.exports = __webpack_public_path__ + "static/media/shell32_139.654b1b6e.ico";